import { message } from 'antd';
import axios from 'axios';
import { useEffect, useState } from 'react';

import ModalSelectProductView from '../../components/modalSelectProduct';

/**
 * Татан авалтын урсгалын "Бараа сонгох" цонх.
 *
 * Хүргэлтийн урсгал (views/orderDelivery/Add/ModalSelectProduct.js)-тай ижил
 * `components/modalSelectProduct` харагдацыг хуваалцана — өмнө нь энэ урсгал
 * өөрийн гэсэн жагсаалт/checkbox-той тусдаа цонхтой байсан.
 *
 * Хайлт нь урсгалдаа тусгай: татан авалт нь агуулахын үлдэгдлээр биш, багцаар
 * (`group`) шүүнэ.
 */
const ModalSelectProduct = ({
  visible = false,
  selectedProducts = [],
  onCancel = () => undefined,
  onSelect = () => undefined,
}) => {
  const [products, setProducts] = useState([]);
  const [searchResult, setSearchResult] = useState();
  const [searchText, setSearchText] = useState('');
  const [loading, setLoading] = useState(false);

  const handleCheckProduct = (index, checked) => {
    setProducts((prev) => prev.map((item, i) => (i === index ? { ...item, checked } : item)));
  };

  const onSearchProduct = (value, event, page = 1) => {
    if (loading) return;

    const searchValue = value || '';
    setSearchText(searchValue);
    setLoading(true);

    axios
      .get(
        `/api/v1.0/product/search?query=${encodeURIComponent(searchValue)}&page=${page}&group=true`
      )
      .then(({ data }) => {
        if (data.statusCode !== 200) return;

        setSearchResult(data.result);

        const docs = data.result?.docs ?? [];
        if (page === 1 && docs.length === 0) {
          setProducts([]);
          message.error('Таны хайсан бараа олдсонгүй!');
          return;
        }

        // Аль хэдийн сонгогдсон бараа нь цонх нээгдэхэд шалагдсан харагдана
        const resProducts = docs.map((item) => ({
          ...item,
          checked: selectedProducts.some((selected) => selected._id === item._id),
        }));

        // Хайлт/шүүлт солигдвол хуучин мөрүүдийг сольж, дараагийн хуудас бол нэмнэ
        const isNextPage = searchText === searchValue && searchResult?.page !== page && page > 1;
        setProducts((prev) => [...(isNextPage ? prev : []), ...resProducts]);
      })
      .catch((e) => {
        console.error('product search: ', e);
      })
      // Амжилттай эсэхээс үл хамааран loading заавал унтарна
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    onSearchProduct();
    //eslint-disable-next-line
  }, []);

  /**
   * Сонголтыг батлана. Шалагдсан шинэ барааг нэмж, шалгалт нь авагдсаныг
   * жагсаалтаас хасна — өмнө нь давхардсан бараа сонгоход алдаа заадаг байсан.
   */
  const onOk = () => {
    const uncheckedIds = products.filter((item) => !item.checked).map((item) => item._id);

    // Хуучин сонголтын тоо ширхэг хадгалагдана
    const kept = selectedProducts.filter((item) => !uncheckedIds.includes(item._id));
    const keptIds = kept.map((item) => item._id);

    const added = products
      .filter((item) => item.checked && !keptIds.includes(item._id))
      .map(({ checked, ...item }) => ({ ...item, totalUnit: Number(item?.totalUnit ?? 1) || 1 }));

    if (kept.length === 0 && added.length === 0) {
      message.error('Та бараагаа сонгож оруулна уу.');
      return;
    }

    onSelect([...kept, ...added]);
    onCancel();
  };

  return (
    <ModalSelectProductView
      isModalVisible={visible}
      handleOk={onOk}
      handleCancel={onCancel}
      onSearchProduct={onSearchProduct}
      productList={products}
      searchText={searchText}
      searchResult={searchResult}
      handleCheckProduct={handleCheckProduct}
      loading={loading}
      centered
    />
  );
};

export default ModalSelectProduct;
